import { Card } from '@/components/ui/card';

const SettingsPage = () => (
  <div className="space-y-6">
    <div>
      <h2 className="text-2xl font-semibold text-white">Settings</h2>
      <p className="text-sm text-slate-400">Toggle feature flags, view environment indicators, and manage integrations.</p>
    </div>

    <Card title="Feature Flags">
      <p className="text-sm text-slate-400">Wires into `feature_flags` table for RBAC-managed toggles.</p>
    </Card>

    <Card title="Integrations">
      <p className="text-sm text-slate-400">Display Stax environment, GA4/Plausible connectors, and webhook status.</p>
    </Card>
  </div>
);

export default SettingsPage;
